import React from 'react'

import styled from 'styled-components'
import { Box } from 'rebass'
import media from '../../../utils/style'

export const ButtonsWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5px;

  border-radius: 10px;
  padding: 5px;

  background-color: #ecf1f6;
`

export const Button = styled.button`
  width: 110px;
  height: 50px;
  cursor: pointer;

  background-color: ${(props) =>
    props.active ? props.theme.colors.blue : 'transparent'};
  color: ${(props) =>
    props.active ? props.theme.colors.white : props.theme.colors.blue};

  border: 0;
  border-radius: 8px;

  font-weight: 700;
`

export const SearchButton = styled.button`
  width: 100%;
  flex-grow: 1;
  height: 50px;
  cursor: pointer;
  background-color: ${(props) => props.theme.colors.green};
  color: ${(props) => props.theme.colors.white};

  border: 0;
  border-radius: 8px;

  font-weight: 700;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    margin-left: 10px;
    margin-top: 2px;
  }

  ${media.LargeScreenUp`
     width: 200px;
     min-width: 200px;
     height: 60px;
  `}
`
export default function UsedNewButtons({ type, setType }) {
  return (
    <ButtonsWrapper>
      <Button active={type === 'used'} onClick={() => setType('used')}>
        Used
      </Button>
      <Button active={type === 'new'} onClick={() => setType('new')}>
        New
      </Button>
    </ButtonsWrapper>
  )
}
